export default () => ({
  show: false,
  query: "",
  focus() {
    this.$refs.searchInput.focus();
  },
  blur() {
    this.$refs.searchInput.blur();
  },
  close() {
    this.show = false;
    Grebify.noScroll(false);
    this.blur();
  },
  open() {
    this.show = true;
    Grebify.noScroll(true);

    // Need timeout to wait for search-drawer to finish css transition otherwise focus wont work
    setTimeout(() => this.focus(), 400);
  },
  toggle() {
    var show = !this.show;
    Grebify.noScroll(!show);
    if (show) {
      this.open();
    } else {
      this.close();
    }
  },
});
